import React from 'react';

import { Box, HStack } from '@chakra-ui/react';

import { StopSignIcon } from 'components/Icons';

interface Props {
  label: string;
}

export const StopSignLabel = (props: Props) => {
  return (
    <HStack>
      <Box boxSize={8}>
        <StopSignIcon color="critical" />
      </Box>
      <Box fontWeight={600}>{props.label}</Box>
    </HStack>
  );
};
